module.exports = __webpack_public_path__ + "static/media/restarDeshabilitado.f5fcef68.svg";